<template>

    <div class="content-body" v-if="!disabled" v-loading="loading">
        <el-row id="confirm_to_pay_header_wrapper">
            <h1 id="confirm_to_pay_header_title">{{$t('bookingOrder.confirmToPayTitle')}}</h1>
            <div id="notify_confirm_booking_div_wrapper">
                <el-row id="notify_confirm_booking_span_wrapper">
                    <h3 id="notify_confirm_booking">{{$t('bookingOrder.bookingWasNotConfirmedNotification')}}</h3>
                </el-row>
            </div>
        </el-row>

        <el-row>
            <div id="selected_date_and_time_range_title_wrapper">
                <p id="selected_date_and_time_range_title">{{$t('bookingOrder.reservationDate')}}</p>
            </div>

            <div id="selected_date_and_time_range_value_wrapper">
                <p id="selected_date_and_time_range_value">{{dateAndTimeRangeWasOrdered}}</p>
            </div>
        </el-row>

        <el-row v-for="(bookingSlotType, key) in bookingSlotTypes" id="slot_type_wrapper">
            <div id="slot_type_title_wrapper">
                <p id="slot_type_title">{{bookingSlotType.name}}</p>
            </div>

            <div id="slot_type_value_wrapper" class="row">
                <p style="margin-top: 3px;">
                    <span id="price_per_slot">{{'¥ ' + (bookingSlotType.pricePerSlot) }}</span>
                    <span id="number_of_type_slot">{{numberOfTypeSlot[key] + " 人"}}</span>
                </p>
            </div>
        </el-row>

        <el-row v-show="isCouponWasUsed" id="applied_coupon_wrapper">
            <div id="applied_coupon_title_wrapper">
                <p id="applied_coupon_title" ref="couponName">{{couponName}}</p>
            </div>

            <div id="applied_coupon_value_wrapper">
                <p id="applied_coupon_value" ref="couponDiscount">{{couponDiscount}}</p>
            </div>
        </el-row>

        <el-row id="total_fee_wrapper">
            <div id="total_fee_title_wrapper">
                <p id="total_fee_title">{{$t('bookingOrder.totalTitle')}}</p>
            </div>

            <div id="total_fee_value_wrapper" class="row">
                <p id="total_fee_currency">¥</p>
                <p id="total_fee_value" ref="totalFee">{{totalFee}}</p>
            </div>
        </el-row>

        <el-row>
            <p id="coupon_code_title">{{$t('bookingOrder.couponCodeTitle')}}</p>
            <div id="input_coupon_code_wrapper" class="row" style="position: relative">
                <el-input id="input_coupon_code" style="width: 50%; float: left" type="text" v-model="couponNumber"
                          :placeholder="$t('bookingOrder.couponCodeInputPlaceholder')"></el-input>
                <el-button
                        style="width: 21%; margin-left:1%; background-color: #4B86E8; color: white; padding-right: 0px; padding-left: 0px"
                        id="apply_button" @click="applyCoupon">{{$t('bookingOrder.applyButton')}}
                </el-button>
                <el-button
                        style="width: 27%; margin-left:1%; background-color: red; color: white; float: right; padding-left: 0px; padding-right: 0px"
                        @click="cancelCoupon" id="cancel_button">{{$t('common.cancelBtn')}}
                </el-button>
            </div>
            <p id="required_coupon_code_message" v-if="showRequiredCouponMessage">
                {{$t('bookingOrder.verifyCouponMessage')}}</p>
        </el-row>

        <el-row id="pay_ordered_booking_button_wrapper">
            <el-button id="pay_ordered_booking_button" @click="payOrderedBooking">
                {{$t('bookingOrder.continueToPayButton')}}
            </el-button>
        </el-row>

        <el-row id="back_button_wrapper">
            <el-button id="back_button" @click="backConfirmDisplayToPay">{{$t("bookingOrder.backButton")}}</el-button>
        </el-row>

    </div>

</template>

<script>
    import BookingApi from "../../../api/booking/BookingApi";
    import AlertService from "../../../service/alert.service";

    export default {
        name: "ConfirmToPay",

        data() {
            return {
                dateAndTimeRangeWasOrdered: null,
                couponNumber: null,
                couponDiscount: null,
                totalFee: 0,
                feePerAdult: null,
                feePerChildren: null,
                numberOfAdults: null,
                numberOfChildren: null,
                disabled: true,
                bookingSlotTypes: [],
                numberOfTypeSlot: [],
                bookingOrder: null,
                showRequiredCouponMessage: false,
                firstTotalFee: 0,
                loading: false,
                isCouponWasUsed: false,
                couponName: null,
            }
        },

        created() {
            this.disabled = true
        },

        computed: {},

        methods: {
            payOrderedBooking() {
                let bookedSlotTypes = [];
                for (let i = 0; i < this.bookingSlotTypes.length; i++) {
                    let bookedSlotType = {
                        slotType: this.bookingSlotTypes[i],
                        numberBookedSlot: this.numberOfTypeSlot[i],

                    }
                    bookedSlotTypes.push(bookedSlotType);
                }

                let bookingDto = {
                    appliedCouponNumber: this.couponNumber,
                    bookingTimeRange: this.bookingOrder.bookingTimeRangeStatus.bookingTimeRange,
                    bookedSlotTypes: bookedSlotTypes,
                    bookingDate: this.$moment(this.bookingOrder.bookingTimeRangeStatus.date).format('YYYY/MM/DD HH:mm:ss'),
                }

                this.$emit('redirectPayAndCreateBooking', bookingDto, this.totalFee);
            },

            show() {
                this.disabled = false;
            },

            hide() {
                this.disabled = true;
            },

            enableLoading() {
                this.loading = true;
            },

            disableLoading() {
                this.loading = false;
            },

            setBookingOrder(bookingOrder) {
                this.bookingOrder = bookingOrder;

                console.log("Booking order 1:")
                console.log(bookingOrder)

                if (this.bookingOrder != null) {
                    let startHour = this.bookingOrder.bookingTimeRangeStatus.bookingTimeRange.startHour;
                    let endHour = this.bookingOrder.bookingTimeRangeStatus.bookingTimeRange.endHour;
                    let startMinute = this.bookingOrder.bookingTimeRangeStatus.bookingTimeRange.startMinute;
                    let endMinute = this.bookingOrder.bookingTimeRangeStatus.bookingTimeRange.endMinute;
                    let timeRange = startHour + ":" + ((startMinute != 0) ? startMinute : "00") + " - " + endHour + ":" + ((endMinute != 0) ? endMinute : "00");

                    this.bookingOrder.bookingTimeRangeStatus.date = this.$route.query.orderedDate
                    this.dateAndTimeRangeWasOrdered = this.$route.query.orderedDate + " " + timeRange;
                    this.bookingSlotTypes = this.bookingOrder.bookingSlotTypes;
                    this.numberOfTypeSlot = this.bookingOrder.numberOfTypeSlot;

                    let totalFee = 0;
                    for (let i = 0; i < this.bookingOrder.bookingSlotTypes.length; i++) {
                        totalFee += this.numberOfTypeSlot[i] * this.bookingSlotTypes[i].pricePerSlot;
                    }
                    this.totalFee = totalFee;
                    this.firstTotalFee = totalFee;
                }
            },

            backConfirmDisplayToPay() {
                this.$emit('backSelectOrderSlot');
                this.couponNumber = null;
                this.couponDiscount = null;
                this.isCouponWasUsed = false;
            },

            applyCoupon() {
                if (this.couponNumber == null || !this.validateCouponNumber(this.couponNumber)) {
                    this.showRequiredCouponMessage = true;
                } else {
                    this.showRequiredCouponMessage = false;
                    this.verifyCoupon();
                }
            },

            cancelCoupon() {
                this.isCouponWasUsed = false;
                this.couponNumber = null;
                this.couponDiscount = null;
                this.totalFee = this.firstTotalFee;
                this.$refs.totalFee.innerText = this.totalFee;
                console.log("Used inner text!")
            },

            checkNotUpperCaseOrNumber(couponNumber) {
                for (let i = 0; i < couponNumber.length; i++) {
                    if (!(!isNaN(couponNumber[i]) || (isNaN(couponNumber[i]) && (couponNumber[i] === couponNumber[i].toUpperCase())))) {
                        return true;
                    }
                }

                return false;
            },

            validateCouponNumber(couponNumber) {
                if (couponNumber.length !== 8 || this.checkNotUpperCaseOrNumber(couponNumber)) {
                    return false;
                }

                return true;
            },

            verifyCoupon() {
                this.loading = true;
                let couponNumber = this.couponNumber;
                let timeRangeCode = this.$route.query.timeRangCode;
                BookingApi.verifyCouponForBookingOfEndUser(couponNumber, timeRangeCode).then(result => {
                    this.loading = false;
                    console.log(result)
                    if (result.verified) {
                        this.isCouponWasUsed = true;
                        this.couponName = result.couponName;
                        this.$refs.couponName.innerText = this.couponName;
                        AlertService.success(this.$t("bookingOrder.applyCouponSuccessfully"))
                        if (result.discountType === "DISCOUNT_BY_PERCENT") {
                            let newTotalFee = this.firstTotalFee - this.firstTotalFee * result.discountValue / 100;
                            console.log(newTotalFee)
                            this.totalFee = newTotalFee;
                            this.$refs.totalFee.innerText = this.totalFee;
                            this.couponDiscount = result.discountValue + "%" + " OFF";
                            this.$refs.couponDiscount.innerText = this.couponDiscount;
                        } else {
                            if (this.firstTotalFee <= result.discountValue) {
                                this.totalFee = 0;
                                this.$refs.totalFee.innerText = this.totalFee;
                            } else {
                                let newTotalFee = this.firstTotalFee - result.discountValue;
                                console.log(newTotalFee)
                                this.totalFee = newTotalFee;
                                this.$refs.totalFee.innerText = this.totalFee;
                            }

                            this.couponDiscount = '¥ ' + result.discountValue;
                            this.$refs.couponDiscount.innerText = this.couponDiscount;
                        }

                    } else {
                        this.isCouponWasUsed = false;
                        if (result.notExist) {
                            AlertService.error(this.$t("bookingOrder.couponNotExisted"))
                        } else {
                            if (!result.beforeActiveTime && !result.expired) {
                                if (result.slotsFull) {
                                    AlertService.error(this.$t("bookingOrder.runOutOfSlots"))
                                }
                            } else {
                                if (result.beforeActiveTime) {
                                    AlertService.error(this.$t("bookingOrder.notYetAvailableForUse"))
                                }

                                if (result.expired) {
                                    AlertService.error(this.$t("bookingOrder.isExpired"))
                                }
                            }
                        }

                        this.totalFee = this.firstTotalFee;
                        this.$refs.totalFee.innerText = this.totalFee;
                        this.couponDiscount = null;
                        this.couponNumber = null;
                    }
                })
            }
        },

    }
</script>

<style scoped lang="scss">
    .content-body {
        margin-left: 25%;
        margin-right: 25%;
    }

    #confirm_to_pay_header_wrapper {
        margin-bottom: 20px
    }

    #confirm_to_pay_header_title {
        text-align: center;
        font-weight: bold;
        font-size: 35px;
        margin-top: -5px
    }

    #notify_confirm_booking_div_wrapper {
        width: 100%;
        border: 1px solid red;
        height: 50px;
        margin-top: -20px;
        border-radius: 10px
    }

    #notify_confirm_booking_span_wrapper {
        padding-top: 10px
    }

    #notify_confirm_booking {
        color: red;
        text-align: center;
        margin-top: 0px;
    }

    #selected_date_and_time_range_title_wrapper {
        width: 30%;
        float: left;
        background-color: #b4d7ff;
        height: 40px
    }

    #selected_date_and_time_range_title {
        margin-top: 10px;
        margin-left: 20px
    }

    #selected_date_and_time_range_value_wrapper {
        width: 70%;
        float: right;
        height: 40px
    }

    #selected_date_and_time_range_value {
        margin-top: 10px;
        margin-left: 40px
    }

    #slot_type_wrapper {
        padding-top: 20px
    }

    #slot_type_title_wrapper {
        width: 30%;
        float: left;
        background-color: #b4d7ff;
    }

    #slot_type_title {
        margin-top: 10px;
        margin-left: 20px
    }

    #slot_type_value_wrapper {
        width: 70%;
        float: right;
        height: 40px
    }

    #price_per_slot {
        margin-top: 10px;
        margin-left: 40px;
        display: inline-block;
        min-width: 60px;
    }

    #number_of_type_slot {
        margin-top: 10px;
        margin-left: 40px
    }

    #applied_coupon_wrapper {
        padding-top: 20px
    }

    #applied_coupon_title_wrapper {
        width: 30%;
        float: left;
        background-color: #cc8500;
        min-height: 40px
    }

    #applied_coupon_title {
        margin-top: 10px;
        margin-left: 20px
    }

    #applied_coupon_value_wrapper {
        width: 70%;
        float: right;
        height: 40px
    }

    #applied_coupon_value {
        margin-top: 10px;
        margin-left: 40px
    }

    #total_fee_wrapper {
        padding-top: 20px
    }

    #total_fee_title_wrapper {
        width: 30%;
        float: left;
        background-color: #b4d7ff;
        height: 40px
    }

    #total_fee_title {
        margin-top: 10px;
        margin-left: 20px
    }

    #total_fee_value_wrapper {
        width: 70%;
        float: right;
        height: 40px
    }

    #total_fee_value {
        margin-top: 10px;
        margin-left: 10px
    }

    #total_fee_currency {
        margin-top: 10px;
        margin-left: 40px
    }

    #coupon_code_title {
        margin-top: 15px;
    }

    #input_coupon_code_wrapper {
        margin-top: -5px
    }

    #required_coupon_code_message {
        margin-top: 5px;
        color: red;
    }

    #pay_ordered_booking_button_wrapper {
        text-align: center;
        margin-top: 20px
    }

    #pay_ordered_booking_button {
        background-color: #4B86E8;
        color: white;
        width: 300px;
        display: inline-block;
    }

    #back_button_wrapper {
        text-align: center;
        margin-top: 10px;
    }

    #back_button {
        width: 300px;
    }

    @media only screen and (max-width: 1024px) {
        .content-body {
            margin-left: 15%;
            margin-right: 15%;
        }
    }

    @media only screen and (max-width: 768px) {
        .content-body {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 450px) {
        .content-body {
            margin-left: 0%;
            margin-right: 0%;
        }

        #back_button {
            width: 100%;
        }

        #pay_ordered_booking_button {
            background-color: #4B86E8;
            color: white;
            width: 100%;
            display: inline-block;
        }

        #input_coupon_code_wrapper {
            width: 100%;
        }

        #input_coupon_code {
            width: 60%;
            float: left;
        }

        #apply_button {
            /* width: 35%;
             float: right;*/
        }

        #total_fee_value {
            margin-top: 10px;
            margin-left: 10px
        }

        #total_fee_currency {
            margin-top: 10px;
            margin-left: 10px
        }

        #applied_coupon_value {
            margin-top: 10px;
            margin-left: 10px
        }

        #price_per_slot {
            margin-top: 10px;
            margin-left: 10px
        }

        #number_of_type_slot {
            margin-top: 10px;
            margin-left: 20px
        }

        #selected_date_and_time_range_value {
            margin-top: 10px;
            margin-left: 10px
        }

        #selected_date_and_time_range_title_wrapper {
            width: 35%;
            float: left;
            background-color: #b4d7ff;
            height: 60px
        }

        #selected_date_and_time_range_title {
            margin-top: 10px;
            margin-left: 5px
        }

        #selected_date_and_time_range_value_wrapper {
            width: 65%;
            float: right;
            height: 60px
        }

        #slot_type_title_wrapper {
            width: 35%;
            float: left;
            background-color: #b4d7ff;
        }

        #slot_type_title {
            margin-top: 10px;
            margin-left: 5px
        }

        #slot_type_value_wrapper {
            width: 65%;
            float: right;
            height: 40px
        }

        #applied_coupon_title_wrapper {
            width: 35%;
            float: left;
            background-color: #cc8500;
            min-height: 40px
        }

        #applied_coupon_title {
            margin-top: 10px;
            margin-left: 5px
        }

        #applied_coupon_value_wrapper {
            width: 65%;
            float: right;
            height: 60px
        }

        #total_fee_title_wrapper {
            width: 35%;
            float: left;
            background-color: #b4d7ff;
            height: 40px
        }

        #total_fee_title {
            margin-top: 10px;
            margin-left: 5px
        }

        #total_fee_value_wrapper {
            width: 65%;
            float: right;
            height: 40px
        }
    }

</style>